import { NavItem } from '@components/v2/layout/AppTemplate/appTemplate.types';
import { useLocation } from 'react-router-dom';
import { ClarityEvents } from '../../../../../../../lib/clarity/types/clarityEvents.types';
import { captureEventWithName } from '../../../../../../../lib/clarity/utils/captureEvent.utils';
import { isMenuItemActive } from '../../../../../../../utils/menuActiveRoute.utils';

const isNavItemActive = (item: NavItem, pathname: string): boolean => {
  if (item.isActive) {
    return item.isActive(pathname);
  }

  if (item.pathname) {
    return isMenuItemActive({ currentPathname: pathname, itemPathname: item.pathname });
  }

  return false;
};

interface UseSidebarNavigationParams {
  onCloseMobileMenu?: () => void;
}

export const useSidebarNavigation = ({ onCloseMobileMenu }: UseSidebarNavigationParams = {}) => {
  const { pathname } = useLocation();

  const isItemActive = (item: NavItem): boolean => isNavItemActive(item, pathname);

  const handleNavItemClick = (item: NavItem) => {
    captureEventWithName(
      ClarityEvents.SHELL_NAVIGATED_BY_SIDEBAR_WITH_NAME,
      item.pathname ?? item.label,
    );
    item.action?.();

    if (isItemActive(item)) {
      onCloseMobileMenu?.();
    }
  };

  return { isItemActive, handleNavItemClick };
};
